export default __webpack_public_path__ + "static/media/49d1a1083c8b44febc1b96d474b0564d.85034537.md";